import { render } from "./AnswerRule.vue?vue&type=template&id=16f06a57&scoped=true&ts=true"
import script from "./AnswerRule.vue?vue&type=script&lang=ts"
export * from "./AnswerRule.vue?vue&type=script&lang=ts"

import "./AnswerRule.vue?vue&type=style&index=0&id=16f06a57&scoped=true&lang=scss"

import exportComponent from "/data/.jenkins/workspace/k8s-shouba-exhibitionhall-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f06a57"]])

export default __exports__